export const name = "REGEXP_REPLACE";
export const summary = `Produces a \`STRING\` value where all substrings that match a regular expression are replaced with a specified value.`;
export const reference = `
## REGEXP_REPLACE

Produces a \`STRING\` value where all substrings that match a regular expression are replaced with a specified value.

\`\`\`
REGEXP_REPLACE(value, regexp, replacement)
\`\`\`

### Description

Returns a \`STRING\` where all substrings of \`value\` that match regular expression \`regexp\` are replaced with \`replacement\`.

You can use backslashed-escaped digits (\\1 to \\9) within the \`replacement\`argument to insert text matching the corresponding parenthesized group in the\`regexp\` pattern. Use \\0 to refer to the entire matching text.

To add a backslash in your regular expression, you must first escape it. For example, \`SELECT REGEXP_REPLACE('abc', 'b(.)', 'X\\\\1');\` returns \`aXc\`. You can also use raw strings to remove one layer of escaping, for example \`SELECT REGEXP_REPLACE('abc', 'b(.)', r'X\\1');\`.

The \`REGEXP_REPLACE\` function only replaces non-overlapping matches. For example, replacing \`ana\` within \`banana\` results in only one replacement, not two.

If the \`regexp\` argument isn't a valid regular expression, this function returns an error.


### Note: GoogleSQL provides regular expression support using the
re2 library; see that documentation for its
regular expression syntax.




### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT REGEXP_REPLACE('# Heading', r'^# ([a-zA-Z0-9\\s]+$)', '<h1>\\\\1</h1>') AS html

/*--------------------------*
 | html |
 +--------------------------+
 | <h1>Heading</h1> |
 *--------------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
